import { render, staticRenderFns } from "./RoomItemSkeleton.vue?vue&type=template&id=0faa4925&"
import script from "./RoomItemSkeleton.vue?vue&type=script&lang=ts&"
export * from "./RoomItemSkeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports